'use es6';

import tinymce from 'tinymce';
import I18n from 'I18n';
import { DrawerTypes } from 'FileManagerLib/Constants';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { __HS_IMAGE } from '../constants/plugins';
import { getPickerComponent } from '../utils/settings';
import { getOpenFilePicker } from '../utils/file';
import { openFileManager } from '../utils/fileManager';
import { addControls } from './controls';
import { addTransforms } from './transforms';
import { getInsertImageHandler } from './handlers';
import { addEventListeners } from './shared';
export const HS_IMAGE = __HS_IMAGE;
function getOpenDisallowedImageUploadAlert() {
  return () => {
    FloatingAlertStore.addAlert({
      titleText: I18n.text('TinymcePlugins.hsimage.disallowedImageUploadAlert.heading'),
      message: I18n.text('TinymcePlugins.hsimage.disallowedImageUploadAlert.message'),
      type: 'warning'
    });
  };
}
export function getOpenImagePicker(editor, initialPanel = undefined) {
  return imageToReplace => {
    const onInsertImage = getInsertImageHandler(editor, imageToReplace, initialPanel);
    openFileManager(editor, DrawerTypes.IMAGE, onInsertImage, initialPanel);
  };
}
function imagePlugin(editor) {
  getPickerComponent(editor, 'FilePicker', 'FilePicker picker component is required for the image plugin');
  if (editor.settings.images_upload_handler) {
    editor.settings.images_upload_handler = editor.settings.images_upload_handler.bind(null, editor);
  }
  const openImagePicker = getOpenImagePicker(editor);
  const openAiImageGenerator = getOpenImagePicker(editor, 'IMAGE_GENERATION');
  editor.on('hsimage:openGeneratePanel', () => openAiImageGenerator());
  addControls(editor, HS_IMAGE, openImagePicker, openAiImageGenerator, getOpenFilePicker(editor));
  addTransforms(editor);
  addEventListeners(editor, getOpenDisallowedImageUploadAlert(editor));
}
tinymce.PluginManager.add(HS_IMAGE, imagePlugin);